import React, {useEffect, useRef, useState} from 'react'
import { ChromePicker, ColorResult } from 'react-color'
import cx from 'classnames'
import styles from './CircleColorPicker.module.css'

type ColorPickerProps = {
    property: string
    value?: string
    onChange: (property: string, value: string) => void
    classes?: string
    label: string
}

const ColorPicker: React.FC<ColorPickerProps> = ({
    property,
    value = '#fc0',
    onChange,
    label,
    classes,
}) => {
    const [visible, setVisible] = useState<boolean>(false)
    const pickerRef = useRef<HTMLDivElement>(null)
    const buttonRef = useRef<HTMLDivElement>(null)

    const handleColorChange = (color: ColorResult) => {
        onChange(property, color.hex)
        // setVisible(false)
    }

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            const target = event.target as Node

            if (
                buttonRef.current && buttonRef.current.contains(target) ||
                pickerRef.current && pickerRef.current.contains(target)
            ) {
                return
            }
            setVisible(false)
        }

        if (visible) {
            document.addEventListener("click", handleClickOutside)
        }
        else {
            document.removeEventListener("click", handleClickOutside)
        }

        return () => {
            document.removeEventListener("click", handleClickOutside)
        }
    }, [visible])

    return (
        <div className={cx(styles['wrapper'], classes)}>
            <span>{label}:</span>
            <div className={'zr-position-relative'}>
                <div
                    className={cx(styles['circle'])}
                    style={{ background: value }}
                    onClick={() => setVisible((prev) => !prev)}
                    ref={buttonRef}
                />
                {visible && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '2.5rem',
                            left: '-112.5px',
                            zIndex: 9999,
                        }}
                        ref={pickerRef}
                    >
                        <ChromePicker
                            color={value}
                            disableAlpha={true}
                            onChange={handleColorChange}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default ColorPicker
